export const HUBSPOT_FLOATING_STACK_BASE =
  'dash-transition-md !fixed !bottom-4 !flex !flex-col !gap-3 print:!hidden';

export const HUBSPOT_STACK_RIGHT = {
  nonChatPanelOpen: 'right-[23rem]',
  default: '!right-4',
} as const;

export function getHubspotStackRightClass(nonChatSidePanelOpen: boolean): string {
  return nonChatSidePanelOpen ? HUBSPOT_STACK_RIGHT.nonChatPanelOpen : HUBSPOT_STACK_RIGHT.default;
}

export const VISION_FAB_RIGHT = {
  whenNonChatSidePanelOpen: {
    gds: '!right-[24.75rem]',
    legacy: '!right-[26.50rem]',
    hubspotNotReady: '!right-[22rem]',
  },
  whenDefault: {
    gds: '!right-[2.75rem]',
    legacy: '!right-[4.50rem]',
    hubspotNotReady: '!right-0',
  },
} as const;

export type HubspotFabVariant = keyof (typeof VISION_FAB_RIGHT)['whenDefault'];

export function hubspotFabVariant(hubspotReady: boolean, isGdsVersion: boolean): HubspotFabVariant {
  if (!hubspotReady) {
    return 'hubspotNotReady';
  }
  return isGdsVersion ? 'gds' : 'legacy';
}

export type VisionFabRightState = {
  nonChatSidePanelOpen: boolean;
  hubspotReady: boolean;
  isGdsVersion: boolean;
};

export function getVisionFabRightClass(state: VisionFabRightState): string {
  const variant = hubspotFabVariant(state.hubspotReady, state.isGdsVersion);
  const branch = state.nonChatSidePanelOpen ? 'whenNonChatSidePanelOpen' : 'whenDefault';
  return VISION_FAB_RIGHT[branch][variant];
}
